import InputField from '@a24/form/InputField'
import Divider from '@a24/ui/Divider'
import Title from '@a24/ui/Title'

const BillingAddress = () => {
  return (
    <div>
      <div>
        <Title className='heading-md mb-6' level='h2' text='Billing Address' />
      </div>
      <Divider className='mb-8' />
      <div className='grid mt-8 gap-6 md:grid-cols-2 md:gap-4 mb-8'>
        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='38 Commerce Street'
          autoComplete='street-address'
          name='street'
          label='Street'
          type='text'
          rules={{
            maxLength: 30,
            required: 'Street address is required'
          }}
        />
        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='New York'
          autoComplete='address-level2'
          name='city'
          label='City'
          type='text'
          rules={{
            maxLength: 30,
            required: 'City is required'
          }}
        />
        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='NY'
          autoComplete='address-level1'
          name='state'
          label='State'
          type='text'
          rules={{
            maxLength: 13,
            required: 'State is required'
          }}
        />
        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='10014'
          autoComplete='postal-code'
          name='zip'
          label='Zip'
          type='tel'
          rules={{
            maxLength: 10,
            required: 'Zip is required'
          }}
        />
        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='USA'
          autoComplete='country'
          name='country'
          label='Country'
          type='text'
          rules={{
            maxLength: 56
          }}
        />
        <InputField
          outerWrapperClassName='hidden'
          name='address_type'
          label='address_type'
          type='text'
          value='billing'
        />
      </div>
    </div>
  )
}

export default BillingAddress
